export function getdata() {
	var obj = {
			headDataI:[
				{
					title:"操作",
					prop:"cz",
					width:"150px",
					custom:true,
				},
				{
					title:'征收项目',
					prop:'ty_0_x_1',
					width: "100px",
					custom: true,
				},
				{
					title: "征收品目",
					custom: true,
					prop: "ty_0_x_2",
					width: "200px",
				}, {
					title: "征收子目",
					custom: true,
					prop: "ty_0_x_3",
					width: "200px",
					
				},{
					title: "税款所属期起",
					custom: true,
					prop: "ty_0_x_4",
					width: "200px",
				},{
					title: "税款所属期止",
					custom: true,
					prop: "ty_0_x_5",
					width: "200px",
				},{
					title: "应税项",
					custom: true,
					prop: "ty_0_x_6",
					width: "200px",
				},{
					title: "*减除项",
					custom: true,
					prop: "ty_0_x_7",
					width: "200px",
				},{
					title: "*应税所得率",
					custom: true,
					prop: "ty_0_x_8",
					width: "200px",
				},{
					title: "*计税（费）依据",
					custom: true,
					prop: "ty_0_x_9",
					width: "200px",
					
				},{
					title: "税（费）率或单位税额",
					custom: true,
					prop: "ty_0_x_10",
					width: "200px"
				},{
					title: "职工人数",
					custom: true,
					prop: "ty_0_x_11",
					width: "200px",
					
				},{
					title: "速算扣除数",
					custom: true,
					prop: "ty_0_x_12",
					width: "200px",
					
				},{
					title: "本期应纳税（费）额",
					custom: true,
					prop: "ty_0_x_13",
					width: "200px"
				},{
					title: "减免性质",
					custom: true,
					prop: "ty_0_x_14",
					width: "200px"
				},{
					title: "本期减免费额",
					custom: true,
					prop: "ty_0_x_15",
					width: "200px"
				},{
					title: "本期已缴税（费）额",
					custom: true,
					prop: "ty_0_x_16",
					width: "200px"
				},{
					title: "本期应补（退）税额",
					custom: true,
					prop: "ty_0_x_17",
					width: "200px"
				},{
					title: "征增值税减征比例",
					custom: true,
					prop: "ty_0_x_18",
					width: "200px"
				},{
					title: "征增值税减征额",
					custom: true,
					prop: "ty_0_x_19",
					width: "200px"
				}
			],
			tableDataII:{
				tylj_bsr:{
					disabletylj_bsr:false,
					tylj_bsr:{
						cellCode:"tylj_bsr",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				tylj_bsrsfzlx:{
					disabletylj_bsrsfzlx:false,
					tylj_bsrsfzlx:{
						cellCode:"tylj_bsrsfzlx",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				tylj_slr:{
					disabletylj_slr:false,
					tylj_slr:{
						cellCode:"tylj_slr",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				tylj_sbrq:'',
				tylj_bsrsfzh:{
					disabletylj_bsrsfzh:false,
					tylj_bsrsfzh:{
						cellCode:"tylj_bsrsfzh",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				tylj_slrq:'',
				tylj_slswjg:{
					disabletylj_slswjg:false,
					tylj_slswjg:{
						cellCode:"tylj_slswjg",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
			},
			tableDataI:[
				{
						title:'流动负债：',
						disabledty_0_x_1:false,
						disabledty_0_x_2:false,
						disabledty_0_x_3:false,
						disabledty_0_x_4:false,
						disabledty_0_x_5:false,
						disabledty_0_x_6:false,
						disabledty_0_x_7:false,
						disabledty_0_x_8:false,
						disabledty_0_x_9:false,
						disabledty_0_x_10:false,
						disabledty_0_x_11:false,
						disabledty_0_x_12:false,
						disabledty_0_x_13:true,
						disabledty_0_x_14:false,
						disabledty_0_x_15:false,
						disabledty_0_x_16:false,
						disabledty_0_x_17:false,
						disabledty_0_x_18:false,
						disabledty_0_x_19:false,
						ty_0_x_1: {
							cellCode:"ty_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_2: {
							cellCode:"ty_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_3: {
							cellCode:"ty_0_x_3",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_4: {
							cellCode:"ty_0_x_4",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_5: {
							cellCode:"ty_0_x_5",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_6: {
							cellCode:"ty_0_x_6",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_7: {
							cellCode:"ty_0_x_7",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_8: {
							cellCode:"ty_0_x_8",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_9: {
							cellCode:"ty_0_x_9",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_10: {
							cellCode:"ty_0_x_10",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_11: {
							cellCode:"ty_0_x_11",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_12: {
							cellCode:"ty_0_x_12",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_12: {
							cellCode:"ty_0_x_12",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_13: {
							cellCode:"ty_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_14: {
							cellCode:"ty_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_15: {
							cellCode:"ty_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_16: {
							cellCode:"ty_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_17: {
							cellCode:"ty_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_18: {
							cellCode:"ty_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_19: {
							cellCode:"ty_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},
					{
						title:'流动负债：',
						disabledty_0_x_1:false,
						disabledty_0_x_2:false,
						disabledty_0_x_3:false,
						disabledty_0_x_4:false,
						disabledty_0_x_5:false,
						disabledty_0_x_6:false,
						disabledty_0_x_7:false,
						disabledty_0_x_8:false,
						disabledty_0_x_9:false,
						disabledty_0_x_10:false,
						disabledty_0_x_11:false,
						disabledty_0_x_12:false,
						disabledty_0_x_13:false,
						disabledty_0_x_14:false,
						disabledty_0_x_15:false,
						disabledty_0_x_16:false,
						disabledty_0_x_17:false,
						disabledty_0_x_18:false,
						disabledty_0_x_19:false,
						ty_0_x_1: {
							cellCode:"ty_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_2: {
							cellCode:"ty_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_3: {
							cellCode:"ty_0_x_3",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_4: {
							cellCode:"ty_0_x_4",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_5: {
							cellCode:"ty_0_x_5",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_6: {
							cellCode:"ty_0_x_6",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_7: {
							cellCode:"ty_0_x_7",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_8: {
							cellCode:"ty_0_x_8",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_9: {
							cellCode:"ty_0_x_9",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_10: {
							cellCode:"ty_0_x_10",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_11: {
							cellCode:"ty_0_x_11",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_12: {
							cellCode:"ty_0_x_12",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_12: {
							cellCode:"ty_0_x_12",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_13: {
							cellCode:"ty_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_14: {
							cellCode:"ty_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_15: {
							cellCode:"ty_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_16: {
							cellCode:"ty_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_17: {
							cellCode:"ty_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_18: {
							cellCode:"ty_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
						ty_0_x_19: {
							cellCode:"ty_0_x_13",
							cellType:"1",
							cellVal:"240040043.08"
						},
					}
			],
		
	}
	return obj
}
